import { ROUTES } from '@/constants/routes'

export default function isWorkspaceOwner({ next, router, store }) {
    if (!store.isWorkspaceOwner) {
        return router.push({ name: ROUTES.accountDetails })
    }

    next()
}
